/**
 * Legacy APIs sometimes return diagnostics instead of customer-facing copy.
 * Match diagnostic syntax, not ordinary words such as "exception" or a number
 * that could be a file-size limit. This is a presentation backstop; callers
 * should prefer explicit error codes and context-specific recovery guidance.
 */
export function isTechnicalErrorMessage(message: string): boolean {
    return [
        /\b(?:SQLSTATE|PDOException|QueryException|TypeError|ReferenceError|SyntaxError|Ziggy|ECONNRESET|ECONNREFUSED|ETIMEDOUT|ENOTFOUND)\b/i,
        /\b(?:GCS|S3|MediaConvert|Supabase|OVP API|AWS SDK)\b.*\b(?:error|failed|failure|denied|exception|unavailable)\b/i,
        /\b(?:AccessDenied|NoSuchKey|SignatureDoesNotMatch|InvalidAccessKeyId)\b/,
        /\bAPI\s+(?:key|credentials?|is not configured|configuration)\b/i,
        /\b(?:could not reach|failed to reach)\b.*\bAPI\b/i,
        /\b(?:HTTP(?:\/\d(?:\.\d)?)?\s+[45]\d{2}|status code\s+[45]\d{2}|cURL error\s+\d+)\b/i,
        /^\s*[45]\d{2}\s+(?:forbidden|unauthorized|not found|bad request|internal server error|service unavailable|gateway timeout)\b/i,
        /\bserver error\s*[:(]?\s*[45]\d{2}\b/i,
        /\b(?:undefined (?:array key|index|variable)|cannot read propert(?:y|ies)|stack trace|method not supported)\b/i,
        /\bClass\s+\S+\s+not found\b/i,
        /\b(?:App|Illuminate|Symfony)\\[A-Za-z\\]+/,
        /\b(?:GET|POST|PUT|PATCH|DELETE)\s+https?:\/\//i,
        /(?:storage\.googleapis\.com|amazonaws\.com|cloudfront\.net)\//i,
        /\[object Object\]/,
    ].some((pattern) => pattern.test(message))
}

/** Presentation only: callers retain the original error for diagnostics. */
export function userFacingError(message: unknown, fallback: string): string {
    if (typeof message !== 'string' || !message.trim() || isTechnicalErrorMessage(message)) {
        return fallback
    }
    return message
}
